import metadata from "#bundle-build-metadata";

/** Build-time Unix timestamp; generated before bundling, never evaluated on device. */
export const BUNDLE_BUILD_TIME = metadata.time;
/** Revision provided by CI, or read locally when the bundle metadata is generated. */
export const BUNDLE_GIT_COMMIT = metadata.gitCommit;
